import React from "react";
import axios from "axios";
import { toast } from "react-toastify";
import StationService from "../services/station_service";

const DeleteInfoStationModal = ({ station, onClose, onDeleted }) => {
  const handleDelete = async () => {
    try {
      await StationService.deleteInfoStation(station.station_id);
      toast.success("Station deleted successfully!");
      onDeleted();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Error deleting station");
    }
  };

  return (
    <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content p-3">
          <div className="modal-header">
            <h5 className="modal-title">Confirm Delete</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            <p>
              Are you sure you want to delete station <b>{station.name}</b> (
              {station.station_id})?
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-danger" onClick={handleDelete}>
              Yes, Delete
            </button>
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteInfoStationModal;